import React from 'react';
import './AnnotationHeading.css'
// NORTON DESIGN SYSTEM
import { Button } from '@wwnds/react';

const AnnotationHeading = ({
  timeline,
  formatTime,
  formatSectionHeaderStr,
  updateTime,
  timelineIndex,
  frameIndex,
  Data,
  frame,
  index,
  fIndex
}) => {
  return (
    <div className="annotation-heading-container-wrapper">
      <div className={index === timelineIndex && fIndex === frameIndex ? "highlight-annotation" : "hide-highlight-annotation"}>
        &#11044;
      </div>
      <Button variant="ghost" style={{ width: "100%", padding: "0px" }} onClick={() => updateTime(frame.in)}
      >
        <h3 className="annotation-div-heading-container annotation-link">
          <span>[{frame ? formatTime(frame.in) : null}]</span>
          {/* <span dangerouslySetInnerHTML={{ __html: formatSectionHeaderStr(timeline.timeline) }}></span> */}
        </h3>
      </Button>
    </div>

  )
}

export default AnnotationHeading